/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Defines settings for various frontend layouts within the Permissions service.
 */
export enum EnumFrontendLayoutSetting {
    /**
     * Layout for the Addresses master data table.
     */
    AddressesTableLayout = 4096,
    /**
     * Layout for the Contacts master data table.
     */
    ContactsTableLayout = 4097,
    /**
     * Layout for the Construction Sites master data table.
     */
    ConstructionSitesTableLayout = 4098,
    /**
     * Layout for the Cost Bearers master data table.
     */
    CostBearersTableLayout = 4099,
    /**
     * Layout for the Cost Centers master data table.
     */
    CostCentersTableLayout = 4100,
    /**
     * Layout for the Payment Terms master data table.
     */
    PaymentTermsTableLayout = 4101,
    /**
     * Layout for the Vehicles master data table.
     */
    VehiclesTableLayout = 4102,
    /**
     * Layout for the Vehicle Types master data table.
     */
    VehicleTypesTableLayout = 4103,
    /**
     * Layout for the Services master data table.
     */
    ServicesTableLayout = 4104,
    /**
     * Layout for the Storage Locations master data table.
     */
    StorageLocationsTableLayout = 4105,
    /**
     * Layout for the Ledger Accounts master data table.
     */
    LedgerAccountsTableLayout = 4106,
    /**
     * Layout for the VATs master data table.
     */
    VatsTableLayout = 4107,
    /**
     * Layout for the AVVs master data table.
     */
    AvvsTableLayout = 4108,
    /**
     * Layout for the Containers table.
     */
    ContainersTableLayout = 4109,
    /**
     * Layout for the Container Types table.
     */
    ContainerTypesTableLayout = 4110,
    /**
     * Layout for the Rent Variants table.
     */
    RentVariantsTableLayout = 4111,
    /**
     * Layout for the Orders table.
     */
    OrdersTableLayout = 8192,
    /**
     * Layout for the Order Positions table.
     */
    OrderPositionsTableLayout = 8193,
    /**
     * Layout for the Weighings table.
     */
    WeighingsTableLayout = 8194,
    /**
     * Layout for the Weighing Positions table.
     */
    WeighingPositionsTableLayout = 8195,
    /**
     * Layout for the Weighing Slips table.
     */
    WeighingSlipsTableLayout = 8196,
    /**
     * Layout for the requisitions table.
     */
    RequisitionsTableLayout = 8197,
    /**
     * Layout for the requisitions table.
     */
    RequisitionPositionsTableLayout = 8198,
    /**
     * Layout for the Container Actions table.
     */
    ContainerActionsTableLayout = 8199,
    /**
     * Layout for the Container Stock table.
     */
    ContainerStockTableLayout = 8200,
    /**
     * Layout for the Planned Container Actions table.
     */
    PlannedContainerActionsTableLayout = 8201,
    /**
     * Layout for the Unbilled Container Rent table.
     */
    UnbilledContainerRentTableLayout = 8202,
    /**
     * Layout for the Storage Transactions table.
     */
    StorageTransactionsTableLayout = 8203,
    /**
     * Layout for the Invoices table.
     */
    InvoicesTableLayout = 12288,
    /**
     * Layout for the Invoice Positions table.
     */
    InvoicePositionsTableLayout = 12289,
    /**
     * Layout for the Invoice Transactions table.
     */
    InvoiceTransactionsTableLayout = 12290,
    /**
     * Layout for the Open Invoices (Offene Posten) table.
     */
    OpenInvoicesTableLayout = 12291,
    /**
     * Layout for the Create Invoices (Fakturalauf) view.
     */
    CreateInvoicesTableLayout = 12292,
    /**
     * Layout for the Cash Journals (Kassenbuch) table.
     */
    CashJournalsTableLayout = 12293,
    /**
     * Layout for the Cash Journal Positions table.
     */
    CashJournalPositionsTableLayout = 12294,
    /**
     * Layout for the Cash Registers table.
     */
    CashRegistersTableLayout = 12295,
    /**
     * Layout for the Price Lists table.
     */
    PriceListsTableLayout = 12296,
    /**
     * Layout for the Price List Positions table.
     */
    PriceListPositionsTableLayout = 12297,
    /**
     * Layout for the portal-facing Invoice Snapshots list.
     */
    InvoiceSnapshotsTableLayout = 12298,
    /**
     * Layout for the portal-facing Invoice Snapshot Positions table.
     */
    InvoiceSnapshotPositionsTableLayout = 12299,
    /**
     * Layout for the Permissions table.
     */
    PermissionsTableLayout = 16384,
    /**
     * Layout for the Groups table in system administration.
     */
    GroupsTableLayout = 16385,
    /**
     * Layout for the Users table in system administration.
     */
    UsersTableLayout = 16386,
    /**
     * Layout for the User Permissions table.
     */
    UserPermissionsTableLayout = 16387,
    /**
     * Layout for the Mandants table in system administration.
     */
    MandantsTableLayout = 16388,
    /**
     * Layout for the Scales table in system administration.
     */
    ScalesTableLayout = 16389,
    /**
     * Layout for the table of external applications.
     */
    ExternalApplicationsTableLayout = 16390,
    /**
     * Layout for the table of external application secrets.
     */
    ExternalApplicationSecretsTableLayout = 16391,
    /**
     * Layout for the Action Event Logs table.
     */
    ActionEventLogsTableLayout = 16392,
    /**
     * Layout for the Command Audit Logs table.
     */
    CommandAuditLogsTableLayout = 16393,
    /**
     * Layout for the Workflow Runs table.
     */
    WorkflowRunsTableLayout = 16394,
    /**
     * Layout for the per-run Workflow Run Steps table.
     */
    WorkflowRunStepsTableLayout = 16395,
    /**
     * Layout for the Workflow Definitions table.
     */
    WorkflowDefinitionsTableLayout = 16396,
    /**
     * Layout for the Counters (Nummernkreise) settings table.
     */
    CountersTableLayout = 20480,
    /**
     * Layout for the Print Options settings table.
     */
    PrintOptionsTableLayout = 20481,
    /**
     * Layout for the Email Statuses table.
     */
    EmailStatusesTableLayout = 20482,
    /**
     * Layout for the Email Settings table.
     */
    EmailSettingsTableLayout = 20483,
}
